export const GET_BLOG = "GET_BLOG"
export const GET_EVERY_BLOG = "GET_EVERY_BLOG"
export const POST_BLOG = "POST_BLOG"
export const UPDATE_BLOG = "UPDATE_BLOG"
export const DELETE_BLOG = "DELETE_BLOG"
export const LOGIN_BLOG = "LOGIN_BLOG"
export const REGISTER_BLOG = "REGISTER_BLOG"
export const LOAD_BLOG = "LOAD_BLOG"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"
export const USER_LOADED = "USER_LOADED"
export const AUTH_ERROR = "AUTH_ERROR"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGOUT = "LOGOUT"
export const REMOVE_ALERT = "REMOVE_ALERT"
export const USER_BLOG = "USER_BLOG"